/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React from "react";

import { Col } from "react-bootstrap";
import ReactPlayer from "react-player";


type ExtraLinkProps = {
    LINK: string;
    INDEX: number;
    ONENDED: any;
};

export const ExtraLinkComponent: React.FC<ExtraLinkProps> = ({
    LINK, INDEX, ONENDED
}): JSX.Element | null => {

    const onEnded = ()=>{
        ONENDED(INDEX);
    }

    return (
        <Col xs={12} className={"user-information-section-header"} style={{marginTop:20}}> 
            <ReactPlayer url={LINK} width={"100%"} controls={false} onEnded={onEnded}/>
        </Col>
        
    );
};

export default ExtraLinkComponent;
